import { AuthService, DataLoaderComponent, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from "@ngneat/transloco";
import { SharedService } from '../shared.service';

@Component({
  selector: 'aof-profil-resim',
  standalone: true,
  imports: [DataLoaderComponent,TohumUiModule],
  templateUrl: './profil-resim.component.html'
})
export class ProfilResimComponent implements OnInit {

  @Input() profilId: string; 
  @Input() adSoyad: string;
  @Output() errorOccurred = new EventEmitter();
  @Output() dataLoaded = new EventEmitter();

  kullaniciId: any;
  hataVarMi:boolean = false;
  hataMesaji:string = '';
  resimId: string = '';
  
  @ViewChild('resimGetir') resimGetir: DataLoaderComponent;

  constructor(private authService: AuthService, private router : Router,
    private translocoService: TranslocoService, private sharedService:SharedService) {
      this.sharedService.resimId$.subscribe((data) => {
        this.resimId = data;
        if (this.resimGetir) {
          this.resimGetir.refresh();
        }
      });
     }

  ngOnInit(): void {
    let user = this.authService.getUser();
    this.kullaniciId = user.id;
  }

  resimGuncelle() {
    this.router.navigateByUrl('aday/profil/resim');
  }

  resimHata(error: any) {
    this.errorOccurred.emit(error);
  }

  resimBasarili() {
    this.dataLoaded.emit();
  }
}
